import * as R from "ramda";

const commonPortalApps = (state: any) =>
  R.pathOr(
    { favoriteApplication: [], applications: [] },
    ["CommonDashboard", "commonPortalApps"],
    state
  );
const addFavApps = (state: any) =>
  R.pathOr(false, ["CommonDashboard", "addFavApps"], state);
const pageLoading = (state: any) =>
  R.pathOr(false, ["CommonDashboard", "loading"], state);
const getNewsAndAnnouncementDetails = (state: any) =>
  R.pathOr([{}], ["CommonDashboard", "NewsAndAnnouncementDetails"], state);
const getAttachmentLoading = (state: any) =>
  R.pathOr(false, ["CommonDashboard", "attachments", "loading"], state);
const getAttachments = (state: any) =>
  R.pathOr([], ["CommonDashboard", "attachments", "list"], state);

const selectors = {
  commonPortalApps,
  addFavApps,
  pageLoading,
  getNewsAndAnnouncementDetails,
  getAttachments,
  getAttachmentLoading,
};

export default selectors;
